import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
    Button,
    Col,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
} from 'reactstrap';
import Swal from 'sweetalert2';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel, faFilePdf } from '@fortawesome/free-solid-svg-icons'
import { relatorioAction, fazendaAction } from '../_actions';

export const ModalProducoesLotePeriodo = ({ openModalProducoesLote, handleCloseModalProducoesLote, props }) => {
    const [dataInicio, setDataInicio] = useState('');
    const [dataFim, setDataFim] = useState('');
    const [fazendaSelecionada, setFazendaSelecionada] = useState(0);
    const dispatch = useDispatch();

    useEffect(() => {
        setFazendaSelecionada(0);
        setDataInicio('');
        setDataFim('');
        const data = new Date();
        const dia = String(data.getDate()).padStart(2, '0');
        const mes = String(data.getMonth() + 1).padStart(2, '0');
        const ano = data.getFullYear();
        setDataFim(`${ano}-${mes}-${dia}`);
    }, [openModalProducoesLote]);

    useEffect(() => {
        if (openModalProducoesLote) {
            dispatch(fazendaAction.getFazendaSelect());
        }
    }, [openModalProducoesLote]);

    const handleValidationDatas = () => {
        let valid = true;
        let errors = '';

        if (!fazendaSelecionada) {
            valid = false;
            errors += '<li style="float:left;">Informe uma fazenda!</li><br>';
        }

        if (!dataInicio) {
            valid = false;
            errors += '<li style="float:left;">Informe uma data de in&iacute;cio!</li><br>';
        }

        if (!dataFim) {
            valid = false;
            errors += '<li style="float:left;">Informe uma data de t&eacute;rmino!</li><br>';
        }

        if (!valid) {
            Swal.fire({
                icon: 'warning',
                title: 'Erros de valida&ccedil;&atilde;o',
                showCloseButton: true,
                showConfirmButton: true,
                html: `<div style="font-size: 14px; text-align: left"><ul>${errors}</ul></div>`
            });
        }
        return valid;
    };

    const renderOptionsFazendas = () => {
        return props.fazenda.fazenda.map((p, i) => (
            { value: p.id, label: p.nome, key: i }
        ));
    };

    const handleSelectChange = (prop) => (event) => {
        if (prop === 'id_fazenda') {
            setFazendaSelecionada(event.value);
        }
    };

    const handleGeraRelatorioProducoesLote = () => {
        if (handleValidationDatas()) {
            const { match: { params } } = props;

            let payload = {
                id: params.id,
                id_fazenda: fazendaSelecionada,
                data_inicio: dataInicio,
                data_termino: dataFim,
                tipo_relatorio: "PL",
            };

            dispatch(relatorioAction.getRelatorio(payload, true));
        }
    };

    const handleGeraRelatorioProducoesLoteExcel = () => {
        if (handleValidationDatas()) {
            const { match: { params } } = props;

            let payload = {
                id: params.id,
                id_fazenda: fazendaSelecionada,
                data_inicio: dataInicio,
                data_termino: dataFim,
                tipo_relatorio: "PL",
                excel: true
            };

            dispatch(relatorioAction.getRelatorio(payload, true));
        }
    };

    return (
        <div>
            <Modal isOpen={openModalProducoesLote} onClose={handleCloseModalProducoesLote} aria-labelledby="form-dialog-title">
                <ModalHeader id="form-dialog-title">Gerar relat&oacute;rio de produ&ccedil;&otilde;es leiteiras por per&iacute;odo</ModalHeader>
                <ModalBody>
                    <FormGroup className="mb-0">
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label className="left" for="selecionarFazenda">Selecione uma fazenda: *</Label>
                                    {openModalProducoesLote &&
                                        <Select
                                            classNamePrefix="select"
                                            value={renderOptionsFazendas().filter(option => option.value === (fazendaSelecionada || 0))}
                                            onChange={handleSelectChange('id_fazenda')}
                                            isSearchable
                                            placeholder="Selecione..."
                                            id="id_fazenda"
                                            name="id_fazenda"
                                            options={renderOptionsFazendas()}
                                        />
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className="mt-1">
                            <Col>
                                <Label className="left" for="data_inicio">Data de in&iacute;cio: *</Label>
                                <Input
                                    id="data_inicio"
                                    label="Data de in�cio *"
                                    className="form-control"
                                    type="date"
                                    InputLabelProps={{ shrink: true }}
                                    value={dataInicio}
                                    onChange={(e) => setDataInicio(e.target.value)}
                                />
                            </Col>
                            <Col>
                                <Label className="left" for="data_fim">Data de fim: *</Label>
                                <Input
                                    id="data_fim"
                                    label="Data de fim *"
                                    className="form-control"
                                    type="date"
                                    InputLabelProps={{ shrink: true }}
                                    value={dataFim}
                                    onChange={(e) => setDataFim(e.target.value)}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={handleCloseModalProducoesLote} color="secondary">Cancelar</Button>
                    <Button onClick={handleGeraRelatorioProducoesLote} color="primary" ><FontAwesomeIcon icon={faFilePdf} style={{ marginRight: 3 }} /> Gerar relat&oacute;rio</Button>
                    <Button
                        color="success"
                        id="btnExcel"
                        onClick={handleGeraRelatorioProducoesLoteExcel}
                    >
                        <FontAwesomeIcon icon={faFileExcel} style={{ marginRight: 4 }} />
                        Gerar Excel
                    </Button>
                </ModalFooter>
            </Modal >
        </div >
    );
};
